import { MeteredPromoBanner } from '@upheal/billing/PlanCard/MeteredPromoBanner/MeteredPromoBanner';
import { getMeteredPricingForRegion } from '@upheal/billing/utils/meteredPricing';
import { Modal } from '@upheal/design-system/components/Modal/Modal';
import { useState } from 'react';
import { HubspotContactForm } from '../HubspotContactForm';
import { useOrganizationExperienceMode } from '../../../../state/useOrganizationExperienceMode';

type MeteredPlanUpgradeProps = {
    planName: string;
    onClose: () => void;
};

export const MeteredPlanUpgrade = ({
    planName,
    onClose,
}: MeteredPlanUpgradeProps) => {
    const { organization } = useOrganizationExperienceMode();
    const [showContactForm, setShowContactForm] = useState(false);

    const handleContactSales = () => {
        setShowContactForm(true);
    };

    if (showContactForm) {
        return <HubspotContactForm onClose={onClose} />;
    }

    return (
        <>
            <Modal.Header title={`Switch to ${planName}`} onClose={onClose} />
            <Modal.Content>
                <MeteredPromoBanner
                    {...getMeteredPricingForRegion(organization?.region)}
                    uiLocation="Feature Lock Modal"
                    onContactSales={handleContactSales}
                />
            </Modal.Content>
        </>
    );
};
